import * as apiUtils from "@/utils/apiUtils"
import * as CurrencyHelper from "@/utils/currencies"

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    mybizes: [],
    mybid: null
  },
  // -----------------------------------------------------------------
  getters: {
    biz: state => () => {
      var biz = JSON.parse(localStorage.getItem("biz"))
      return biz
    },
    bid: state => () => {
      var biz = JSON.parse(localStorage.getItem("biz"))
      return biz ? biz.id : null
    },
    currencyCode: state => () => {
      var biz = JSON.parse(localStorage.getItem("biz"))
      return biz.currencyCode
    },
    currencySymbol: state => () => {
      var biz = JSON.parse(localStorage.getItem("biz"))
      return CurrencyHelper.getCurrencySymbol(biz.currencyCode)
    },
    mybizes: state => () => {
      return state.mybizes
    },
    displayId: state => () => {
      var biz = JSON.parse(localStorage.getItem("biz"))
      return biz.displayId
    }
  },
  // -----------------------------------------------------------------
  mutations: {
    updateBiz: (state, biz) => {
      state.mybid = biz ? biz.bid : null
      localStorage.setItem("biz", JSON.stringify(biz))
    },
    updateMyBizes: (state, bizes) => {
      state.mybizes = bizes
    },
    removeBiz: state => {
      localStorage.removeItem("biz")
    }
  },
  // -----------------------------------------------------------------
  actions: {
    getBizes: (context, query) => {
      var path = "/bizes"
      // var path = "/bizes?owned=" + owned
      return apiUtils.get(path, query)
    },
    getBiz: (context, id) => {
      var path = "/bizes/" + id
      return apiUtils.get(path)
    },
    createBiz: (
      context,
      {
        displayId,
        email,
        name,
        type,
        taxId,
        currencyCode,
        timezone,
        countryCode,
        phone,
        fax,
        mobile,
        accountNumber,
        bankSwiftCode,
        bankName,
        bankAddress,
        website,
        billingPostalCode,
        billingAddress,
        billingAddress2
      }
    ) => {
      var path = "/bizes"

      return apiUtils.post(path, {
        displayId,
        email,
        name,
        type,
        taxId,
        currencyCode,
        timezone,
        countryCode,
        phone,
        fax,
        mobile,
        accountNumber,
        bankSwiftCode,
        bankName,
        bankAddress,
        website,
        billingPostalCode,
        billingAddress,
        billingAddress2
      })
    },
    updateBiz: (
      context,
      {
        id,
        name,
        email,
        countryCode,
        taxId,
        phone,
        fax,
        mobile,
        accountNumber,
        bankSwiftCode,
        bankName,
        bankAddress,
        website,
        billingPostalCode,
        billingAddress,
        billingAddress2
      }
    ) => {
      var path = "/bizes/" + id

      return apiUtils.patch(path, {
        name,
        email,
        countryCode,
        taxId,
        phone,
        fax,
        mobile,
        accountNumber,
        bankSwiftCode,
        bankName,
        bankAddress,
        website,
        billingPostalCode,
        billingAddress,
        billingAddress2
      })
    },
    getBizTypes: context => {
      var path = "/biz-types"
      return apiUtils.get(path)
    },
    updateBizInfo: (context, biz) => {
      context.commit("updateBiz", biz)
    },
    updateMyBizes: (context, bizes) => {
      context.commit("updateMyBizes", bizes)
    },
    deleteBiz: (context, id) => {
      var path = "/bizes/" + id
      return apiUtils.delete(path)
    },
    logout: context => {
      context.commit("removeBiz")
    }
  }
}
